var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C1818",
    d: "M12.557 9.5 4.65 8v11.084c0 .506.382.916.853.916h13.644c.47 0 .852-.41.852-.916V15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A32121",
    d: "M12.557 0H5.503c-.47 0-.853.41-.853.916V5l7.907 5 4.186 1.5L20 10V5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C1010",
    d: "M4.65 5h7.907v5H4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M10.31 4H4.65v12.5h5.66c.47-.002.85-.411.852-.916V4.917c-.002-.506-.382-.915-.853-.917",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M9.844 4.5H4.65V17h5.194c.47-.002.851-.411.853-.916V5.417c-.002-.506-.382-.915-.853-.917",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M9.844 4.5H4.65V16h5.194c.47-.002.851-.411.853-.916V5.417c-.002-.506-.382-.915-.853-.917",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M9.38 4.5H4.65V16h4.73c.47-.002.85-.411.852-.916V5.417c-.002-.506-.383-.915-.853-.917",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#file_svg__b)",
    d: "M.853 4.5H9.38c.47 0 .853.41.853.917v9.167c0 .506-.382.916-.853.916H.853c-.471 0-.853-.41-.853-.916V5.417C0 4.91.382 4.5.853 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C43333",
    d: "M19.148 0h-6.59v5H20V.916C20 .41 19.62 0 19.148 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C1010",
    d: "M12.559 10H20v5H12.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.16 13.838c-.44-.454.036-1.078 1.33-1.741l.813-.418.317-.715c.174-.394.435-1.036.578-1.427l.262-.712-.18-.526c-.222-.648-.3-1.62-.16-1.97.19-.474.813-.426 1.06.082.193.397.173 1.115-.055 2.021l-.188.743.165.29c.09.158.356.535.589.837l.438.563.545-.074c1.733-.233 2.326.163 2.326.732 0 .717-1.36.776-2.502-.051-.257-.187-.434-.372-.434-.372s-.715.15-1.068.249c-.363.1-.545.164-1.077.35 0 0-.187.28-.31.483-.452.758-.981 1.385-1.36 1.614-.422.255-.866.273-1.089.042m.691-.254c.248-.158.749-.77 1.096-1.337l.14-.23-.64.332c-.987.512-1.439.995-1.204 1.287.132.164.29.15.608-.052m6.416-1.858c.242-.175.207-.528-.067-.67-.213-.11-.385-.133-.938-.125-.34.024-.887.095-.98.116 0 0 .3.214.434.293.177.105.609.3.924.399.31.098.49.087.627-.013m-2.58-1.106a6.5 6.5 0 0 1-.554-.737c-.206-.28-.31-.477-.31-.477s-.151.5-.275.803l-.387.986-.112.223s.596-.201.9-.283c.32-.087.973-.219.973-.219zm-.831-3.44c.037-.323.053-.647-.048-.81-.28-.315-.617-.052-.56.698.02.252.08.683.162.949l.147.483.104-.364c.057-.2.145-.63.195-.956"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_svg__b",
    x1: 1.778,
    x2: 9.205,
    y1: 3.784,
    y2: 15.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#881818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7E1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660B0B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "file_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFile;